import useFormat from '../../hooks/useFormat';
import usePrice from '../../hooks/usePrice';

const CartTotalPrice = ({ product_variation, quantity }) => {
    const { formatPrice }  = useFormat();
    const { productPrice } = usePrice({
        variation : product_variation,
        product   : product_variation.product,
        quantity  : quantity,
    });
    const { totalPrice } = productPrice;

    return(        
        <div className="flex flex-shrink-0 flex-grow-0 justify-center">              
            {formatPrice(totalPrice)}
        </div>        
    );
};

export default CartTotalPrice;
